"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACCESS_CONTROL_EXPOSE_HEADERS_KEY = void 0;
exports.ACCESS_CONTROL_EXPOSE_HEADERS_KEY = 'Access-Control-Expose-Headers';
//# sourceMappingURL=consts.js.map